import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import Link from 'blocks.simple/link/link'
import translate from 'core/translate'
import { Steps } from 'atoms/Steps/Steps-view'
import { useLocation } from 'react-router'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import styles from './instancesCatalog_askona.jcss'
import { AskonaSelectedItems, ASKONA_CATALOG_TITLE_KEY } from './InstancesCatalogAskona-types'

const categories = ['slides', 'buttons', 'recommended'] as const

const InstancesCatalogAskonaComponent = () => {
    const location = useLocation()
    const category = categories.find((item) => item === getURLSearchParamsByLocation(location).category) || 'slides'
    const [selectedItems, setSelectedItems] = useState<AskonaSelectedItems>([])

    useEffect(() => {
        setSelectedItems([])
    }, [category])

    return (
        <Content title={ASKONA_CATALOG_TITLE_KEY}>
            <div className={styles.wrapper}>
                <Steps active={category} className={styles.tabs}>
                    {categories.map((item) => (
                        <Link
                            id={item}
                            key={item}
                            to={{
                                pathname: location.pathname,
                                search: getURLSearchParamsString({ category: item }),
                            }}
                        >
                            {translate(item)}
                        </Link>
                    ))}
                </Steps>
                <CustomList
                    key={category}
                    type={`askona${category[0].toUpperCase()}${category.slice(1)}`}
                    onSelect={setSelectedItems}
                    selectedItems={selectedItems}
                    isDelayTime
                    additionalData={{}}
                />
            </div>
        </Content>
    )
}

export const InstancesCatalogAskona = checkAvailableModule('instancesCatalog/askona')
    ? InstancesCatalogAskonaComponent
    : null
